import apiClient from './api';
import axios from 'axios';
import config from '../config';

// Önbellek mekanizması
const cache = {
  countries: null,
  autoComplete: new Map()
};

export const geoService = {
  async getCountries() {
    // Önbellekte varsa, önbellekten getir
    if (cache.countries) {
      return cache.countries;
    }
    
    try {
      // Yönlendirmeleri takip etmek için doğrudan axios kullanıyoruz
      const response = await axios.get(`${config.API_BASE_URL}geo/countries`, {
        maxRedirects: 5, // Maksimum 5 yönlendirmeye izin ver
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true // CORS ile ilgili çerezleri gönder
      });
      
      const data = response.data;
      
      // Sonucu önbelleğe kaydet
      cache.countries = data;
      
      return data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  },
  
  async getAutoComplete(search) {
    // Önbellekte varsa, önbellekten getir
    if (cache.autoComplete.has(search)) {
      return cache.autoComplete.get(search);
    }
    
    try {
      // Kullanıcı token'ını al
      const userData = JSON.parse(localStorage.getItem('user_data'));
      const token = userData?.token;
      
      // Yönlendirmeleri takip etmek için doğrudan axios kullanıyoruz
      const response = await axios.get(`${config.API_BASE_URL_V1}auto-complete?search=${search}`, {
        maxRedirects: 5, // Maksimum 5 yönlendirmeye izin ver
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        withCredentials: true // CORS ile ilgili çerezleri gönder
      });
      
      const data = response.data.data;
      
      // Sonucu önbelleğe kaydet
      cache.autoComplete.set(search, data);
      
      return data;
    } catch (error) {
      console.error('Error fetching auto-complete:', error);
      throw error;
    }
  },
  
  // Önbelleği temizleme
  clearCache() {
    cache.countries = null;
    cache.autoComplete.clear();
  }
};

export default geoService; 